module.exports = __webpack_public_path__ + "img/erwin.16228994.jpg";